<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts, requisites} from "@js/company_details.ts";
import {formatPhone} from "@js/helpers.ts";
import {Link} from "@inertiajs/vue3";

export default {
    name: "PublicOfferPage",
    components: {Link, MobileTopBar, Breadcrumbs},
    setup() {
        return {contacts, requisites, formatPhone};
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">Публичная оферта</h1>
        <hr class="mt-5 mb-5"/>

        <!-- Основные понятия -->
        <div class="mb-10">
            <h2 class="text-xl font-medium mb-5">Основные понятия</h2>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Посетитель Сайта</span> — лицо, пришедшее на сайт
                https://metallolom1-prokat.ru без цели размещения Заказа.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Пользователь</span> — физическое лицо, посетитель Сайта, принимающий
                условия настоящей Оферты и желающий разместить Заказы в Интернет-магазине.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Покупатель</span> — Пользователь, разместивший Заказ в
                Интернет-магазине.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Металлолом-1</span> — Общество с ограниченной ответственностью
                «Металлолом-1», ИНН {{ requisites.inn }}, КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Юридический адрес:</span> {{ requisites.ur_address }}
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Продавец</span> — ООО «Металлолом-1» или иное юридическое лицо/ИП,
                размещающее товары на сайте.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Интернет-магазин</span> — сайт https://metallolom1-prokat.ru, где
                размещены товары, условия оплаты и доставки.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Сайт</span> — https://metallolom1-prokat.ru
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Товар</span> — металлопрокат и металлоизделия: арматура, арматурные
                каркасы,
                балки двутавровые, швеллер, уголок, квадрат, листовой прокат
                (горячекатаный/холоднокатаный/оцинкованный),
                труба профильная/электросварная/оцинкованная/ВГП, проволока вязальная, сетка сварная (карты/рулоны),
                профнастил, винтовые сваи, метизы и сопутствующие товары.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Заказ</span> — оформленный запрос на покупку и поставку Товара по
                адресу
                Покупателя либо самовывозом.
            </p>
        </div>

        <!-- 1. Общие положения -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">1. Общие положения</h2>
            <p class="text-sm mb-2">
                1.1. Продавец осуществляет продажу Товаров через Интернет-магазин по адресу
                https://metallolom1-prokat.ru/.
            </p>
            <p class="text-sm mb-2">
                1.2. Заказывая Товары через Интернет-магазин, Пользователь соглашается с условиями продажи Товаров,
                изложенными ниже (далее — «Условия продажи товаров»). В случае несогласия с настоящей Публичной офертой
                Пользователь обязан прекратить использование сервиса и покинуть сайт https://metallolom1-prokat.ru/.
            </p>
            <p class="text-sm mb-2">
                1.3. Настоящие Условия продажи товаров и информация о Товаре, представленная на Сайте, являются
                публичной
                офертой в соответствии со ст. 435 и п. 2 ст. 437 ГК РФ.
            </p>
            <p class="text-sm mb-2">
                1.4. Соглашение может быть изменено Продавцом в одностороннем порядке без уведомления
                Пользователя/Покупателя.
                Новая редакция вступает в силу по истечении 10 (десяти) календарных дней с момента публикации на Сайте,
                если иное не предусмотрено Соглашением.
            </p>
            <p class="text-sm mb-2">
                1.5. Публичная оферта признается акцептованной с момента регистрации на Сайте, оформления Заказа
                (в том числе без авторизации), а также с момента принятия Заказа по телефону
                {{ formatPhone(contacts.sales_department_phone) }} или по почте {{ contacts.info_mail }}. Договор купли-продажи
                считается
                заключенным с момента выдачи кассового/товарного чека или иного документа, подтверждающего оплату.
            </p>
            <p class="text-sm mb-2">
                1.6. Продавец вправе поручить исполнение Договора третьему лицу, оставаясь ответственным перед
                Покупателем.
            </p>
            <p class="text-sm mb-2">
                1.7. В рамках Заказа Продавец предоставляет информационное сопровождение заключенного Договора.
            </p>
            <p class="text-sm mb-2">
                1.8. Цены на металлопрокат подвержены колебаниям рынка. Стоимость и наличие Товара, указанные на Сайте,
                являются ориентировочными до подтверждения менеджером. Счет/коммерческое предложение действительно
                ограниченное время (как правило, в течение 1 рабочего дня) либо в срок, указанный в документе.
            </p>
        </div>

        <!-- 2. Регистрация -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">2. Регистрация на сайте</h2>
            <p class="text-sm mb-2">2.1. Регистрация осуществляется через вкладку «Регистрация».</p>
            <p class="text-sm mb-2">2.2. Регистрация не обязательна для оформления Заказа.</p>
            <p class="text-sm mb-2">2.3. Продавец не несет ответственности за точность данных, предоставленных
                Пользователем.</p>
            <p class="text-sm mb-2">
                2.4. Пользователь обязуется не сообщать третьим лицам логин и пароль. При подозрении на компрометацию
                необходимо незамедлительно уведомить Продавца по адресу: {{ contacts.info_mail }}.
            </p>
            <p class="text-sm mb-2">
                2.5. Общение с представителями Продавца должно соответствовать нормам морали и делового этикета.
            </p>
        </div>

        <!-- 3. Товар и покупка -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">3. Товар и порядок совершения покупки</h2>
            <p class="text-sm mb-2">
                3.1. Фотографии носят иллюстративный характер и могут незначительно отличаться от фактического вида
                Товара
                (наличие окалины, следов консервационной смазки, незначительных следов коррозии на поверхности, оттенок
                цинкового
                покрытия и т.д.). Описания и характеристики приведены для справки и могут содержать опечатки.
            </p>
            <p class="text-sm mb-2">
                3.2. При отсутствии заказанного Товара на складе Продавец вправе исключить позицию из
                Заказа/аннулировать Заказ,
                уведомив Покупателя по e-mail, указанному при оформлении/регистрации.
            </p>
            <p class="text-sm mb-2">
                3.3. В случае аннуляции предоплаченного Заказа стоимость аннулированного Товара возвращается способом,
                которым была произведена оплата.
            </p>
            <p class="text-sm mb-2">
                3.4. Покупатель несет ответственность за корректность предоставленных данных.
            </p>
            <p class="text-sm mb-2">
                3.5. После оформления Заказа менеджер уточняет детали, согласовывает дату поставки/самовывоза, проверяет
                наличие и актуализирует цену.
            </p>
            <p class="text-sm mb-2">
                3.6. Масса и метраж рассчитываются по фактическим данным при отгрузке. Допускаются технологические
                отклонения
                по длинам и массе в рамках ГОСТ/ТУ. Расчет по «теоретической массе» используется в справочных целях,
                если иное
                не оговорено.
            </p>
            <p class="text-sm mb-2">
                3.7. Услуги порезки/резки «в размер», сверления, гибки, сварки, грунтования и иные операции относятся к
                индивидуальным работам и не подлежат возврату/обмену. Такие услуги выполняются после согласования ТЗ и
                оплаты
                (полной или частичной — согласно счету).
            </p>
            <p class="text-sm mb-2">
                3.8. Сертификаты соответствия/качества предоставляются при наличии у производителя/склада (паспорт
                плавки,
                сертификат качества и т.п.).
            </p>
        </div>

        <!-- 4. Доставка -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">4. Доставка заказа</h2>
            <p class="text-sm mb-2">
                4.1. Способы доставки указаны в разделе «Доставка»:
                <Link :href="route('deliveryAndShipping')"
                      class="underline hover:text-navHoverColor leading-tight transition font-bold">
                    https://metallolom1-prokat.ru/delivery-and-shipping
                </Link>
                .
            </p>
            <p class="text-sm mb-2">
                4.2. Территория доставки ограничена Москвой и Московской областью; в другие регионы — через ТК.
                Продавец не несет ответственности за услуги сторонней логистической компании.
            </p>
            <p class="text-sm mb-2">
                4.3. Стоимость доставки рассчитывается индивидуально исходя из габаритов, массы, удаленности, способа
                разгрузки и формы оплаты.
            </p>
            <p class="text-sm mb-2">
                4.4. Разгрузка и подача на объект организуются силами Покупателя, если иное не согласовано. При
                необходимости
                крана/манипулятора/погрузчика услуги оформляются и оплачиваются отдельно. Доступ для грузового
                транспорта,
                разрешение на въезд, пропуска — обязанность Покупателя.
            </p>
            <p class="text-sm mb-2">
                4.5. При доставке Заказ передается Получателю, указанному в документах. Для предоплаченных заказов
                курьер/водитель
                вправе запросить документ, удостоверяющий личность. Продавец обеспечивает конфиденциальность
                персональных данных.
            </p>
            <p class="text-sm mb-2">
                4.6. Риск случайной гибели/повреждения Товара переходит к Покупателю с момента передачи Товара
                перевозчику
                (при отгрузке со склада) либо Получателю (при собственной доставке Продавца) и подтверждается подписью в
                документах. Время нахождения транспорта на разгрузке ограничено (как правило, 30 минут); простой
                оплачивается
                дополнительно по тарифу.
            </p>
        </div>

        <!-- 5. Оплата -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">5. Оплата товара</h2>
            <p class="text-sm mb-2">
                Цены указываются в рублях РФ и включают НДС, если иное не указано. Допустимы способы оплаты:
                безналичный расчет по счету (для юр/физ лиц), банковской картой (при наличии такой возможности),
                наличными
                при самовывозе/доставке (если предусмотрено).
            </p>
            <p class="text-sm mb-2">
                Цена Товара на Сайте может изменяться. Цена подтвержденного Заказа не изменяется, кроме случаев
                истечения
                срока действия счета/КП до оплаты или изменения спецификации по инициативе Покупателя.
            </p>
            <p class="text-sm mb-2 font-bold">5.1. Особенности оплаты банковскими картами (при доступности):</p>
            <p class="text-sm mb-2">
                5.1.1. Операции совершаются держателем карты или уполномоченным лицом; банк-эмитент вправе отказать при
                подозрении на мошенничество.
            </p>
            <p class="text-sm mb-2">
                5.1.2. Заказы, предоплаченные картой, могут запрашиваться к дополнительной верификации личности.
            </p>
            <p class="text-sm mb-2">
                5.1.3. Скидки/бонусы/акции устанавливаются Продавцом, условия указаны на Сайте и могут меняться.
            </p>
            <p class="text-sm mb-2">
                5.2. Счет/коммерческое предложение действительно ограниченный срок (обычно 1 рабочий день), после чего
                требуется актуализация из-за изменения рыночных котировок.
            </p>
        </div>

        <!-- 6. Возврат -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">6. Возврат товара и денежных средств</h2>
            <p class="text-sm mb-2">
                6.1. Продавец предоставляет достоверную информацию о Товаре. Оплата означает согласие с условиями
                продажи,
                в т.ч. со спецификацией, допусками и способами приемки.
            </p>
            <p class="text-sm mb-2">
                6.2. Расчет массы/метража, сделанный Продавцом на основании исходных данных Покупателя, носит
                консультативный характер и не может являться основанием претензий. Отгрузка ведется по фактической
                массе/количеству
                согласно документам склада и ГОСТ/ТУ.
            </p>
            <p class="text-sm mb-2">
                6.3. Приемка по количеству/ассортименту/комплектности осуществляется Покупателем при отгрузке/получении.
                Претензии по указанным параметрам принимаются только в момент приемки и фиксируются актом (в т.ч.
                ТОРГ-2)
                при участии представителя перевозчика/Продавца.
            </p>
            <p class="text-sm mb-2">
                6.4. Товар надлежащего качества подлежит возврату/обмену в течение 7 дней с момента передачи, если он не
                был в употреблении и сохранены товарный вид, упаковка/обвязка, ярлыки, маркировка тепла/плавки и
                документы,
                подтверждающие покупку. Возврат осуществляется силами и за счет Покупателя на склад Продавца.
            </p>
            <p class="text-sm mb-2">
                6.5. Не подлежат возврату/обмену: Товары, подвергшиеся резке, гибке, сверлению, сварке, окраске, а также
                изготовленные/обработанные индивидуально под размеры Покупателя.
            </p>
            <p class="text-sm mb-2">
                6.6. При отказе Покупателя от Товара Продавец возвращает стоимость Товара за вычетом расходов на
                доставку
                и иные фактические затраты в течение 10 дней с даты получения письменного заявления и Товара.
            </p>
            <p class="text-sm mb-2">
                6.7. При отсутствии аналогичного Товара для обмена Покупатель вправе потребовать возврат денежных
                средств.
            </p>
        </div>

        <!-- 7. Ответственность -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">7. Ответственность</h2>
            <p class="text-sm mb-2">
                Продавец не несет ответственности за ущерб, причиненный ненадлежащим использованием Товара.
                Продавец не отвечает за содержание и работу внешних сайтов, а также за качество Товара, реализуемого
                иными
                продавцами на площадке. Продавец содействует урегулированию претензий, предоставляя имеющуюся
                информацию,
                не являющуюся конфиденциальной.
            </p>
        </div>

        <!-- 8. Конфиденциальность -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">8. Конфиденциальность и защита информации</h2>
            <p class="text-sm mb-5">
                Персональные данные обрабатываются согласно ФЗ № 152-ФЗ «О персональных данных». При регистрации
                Пользователь предоставляет Фамилию, Имя, телефон и e-mail. Предоставляя персональные данные,
                Пользователь
                соглашается на их обработку для исполнения обязательств по Оферте, продвижения товаров и услуг,
                проведения опросов, клиентской поддержки, организации доставки, розыгрышей, контроля удовлетворенности и
                качества сервиса.
            </p>
            <p class="text-sm mb-2">
                8.1. Продавец вправе отправлять информационные (в т.ч. рекламные) сообщения при наличии согласия
                Пользователя.
                Отказ возможен по телефону {{ formatPhone(contacts.sales_department_phone) }} или письмом на {{
                    contacts.info_mail
                }}.
            </p>
            <p class="text-sm mb-2">
                8.2. Сервисные сообщения (о заказе) отправляются автоматически и не могут быть отклонены.
            </p>
            <p class="text-sm mb-2">
                8.3. Продавец вправе использовать cookies и получает информацию об IP-адресе посетителя. Данные не
                используются для установления личности. Телефонные разговоры могут записываться для повышения качества
                сервиса.
            </p>
        </div>

        <!-- 9. Срок действия -->
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">9. Срок действия Публичной оферты</h2>
            <p class="text-sm mb-2">
                Оферта действует с момента акцепта и до отзыва акцепта Публичной оферты.
            </p>
        </div>

        <!-- 10. Дополнительные условия -->
        <div>
            <h2 class="text-xl mb-5 font-medium">10. Дополнительные условия</h2>
            <p class="text-sm mb-2">
                Продавец вправе переуступать права и обязанности третьим лицам. Интернет-магазин и сервисы могут быть
                временно недоступны по техническим причинам. Применяется законодательство РФ. Споры решаются путем
                переговоров, при недостижении соглашения — в судебном порядке. Недействительность отдельного положения
                не влечет недействительность остальных.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.prose a {
    @apply text-yellow-600 hover:text-yellow-800 underline;
}
</style>
